module.exports = __webpack_public_path__ + "static/media/IMG_4594 oven module close.c4211ab0.JPG";